import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import moment from 'moment';
import 'moment/locale/de';
import {
  useUpdateLogCommentMutation,
  useDeleteLogCommentMutation,
} from '../../redux/api/logbookApi';
import { useApiErrorToast } from '../../hooks/useApiError';

const CommentItem = ({ comment }) => {
  const userId = useSelector((state) => state.auth.id);
  const isSuperUser = useSelector((state) => state.auth.isSuperUser);
  const canModify = isSuperUser || comment.created_by === userId;

  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(comment.body);
  const apiErrorToast = useApiErrorToast();

  const [updateComment, { isLoading: saving }] = useUpdateLogCommentMutation();
  const [deleteComment] = useDeleteLogCommentMutation();

  const handleSave = async () => {
    const body = draft.trim();
    if (!body) return;
    try {
      await updateComment({ id: comment.id, body }).unwrap();
      setEditing(false);
      toast.success('Kommentar aktualisiert');
    } catch (err) {
      apiErrorToast(err, 'Speichern fehlgeschlagen');
    }
  };

  const handleDelete = async () => {
    if (!window.confirm('Kommentar löschen?')) return;
    try {
      await deleteComment(comment.id).unwrap();
      toast.success('Kommentar gelöscht');
    } catch (err) {
      apiErrorToast(err, 'Löschen fehlgeschlagen');
    }
  };

  return (
    <div className='border-start ps-3 py-2'>
      <div className='d-flex justify-content-between align-items-baseline'>
        <div className='small fw-semibold'>
          <i className='fas fa-user me-1 text-muted' />
          {comment.created_by_username}
          <span className='text-muted fw-normal ms-2'>
            {moment(comment.created_at).locale('de').calendar()}
          </span>
        </div>
        {canModify && !editing && (
          <div className='btn-group btn-group-sm'>
            <button
              className='btn btn-link btn-sm text-muted p-0 me-2'
              onClick={() => {
                setDraft(comment.body);
                setEditing(true);
              }}
            >
              <i className='fas fa-pen' />
            </button>
            <button
              className='btn btn-link btn-sm text-danger p-0'
              onClick={handleDelete}
            >
              <i className='fas fa-trash' />
            </button>
          </div>
        )}
      </div>
      {editing ? (
        <div className='mt-1'>
          <textarea
            className='form-control form-control-sm'
            rows={2}
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
          />
          <div className='mt-1'>
            <button
              className='btn btn-primary btn-sm me-2'
              disabled={saving}
              onClick={handleSave}
            >
              Speichern
            </button>
            <button
              className='btn btn-outline-secondary btn-sm'
              onClick={() => setEditing(false)}
            >
              Abbrechen
            </button>
          </div>
        </div>
      ) : (
        <div className='small mt-1' style={{ whiteSpace: 'pre-wrap' }}>
          {comment.body}
        </div>
      )}
    </div>
  );
};

export default CommentItem;
